//manage billing cycle

import {getAttributes} from "./configuration";

import {LOCALE_LANG_OPTIONS, LOCALE_STRING_OPTIONS} from "./common";

export const getCycle = (name) => {
    switch (name) {
        case 'Monthly':
            return '/mo'
        case 'Quarterly':
            return '/3mo'
        case 'Semi-Annually':
            return '/6mo'
        case 'Annually':
            return '/yr'
        case 'Biennially':
            return '/2yr'
        case 'Triennially':
            return '/3yr'
        case 'One Time':
            return ''
        case '1 Year':
            return '/yr'
        case '2 Years':
            return '/2yr'
        case '3 Years':
            return '/3yr'
        case '4 Years':
            return '/4yr'
        case '5 Years':
            return '/5yr'
        case '6 Years':
            return '/6yr'
        case '7 Years':
            return '/7yr'
        case '8 Years':
            return '/8yr'
        case '9 Years':
            return '/9yr'
        case '10 Years':
            return '/10yr'
        default:
            return '/mo'
    }
}

export const getMonthlyPriceBasedOnOtherCycle = (priceList, cycle) => {
    const selectedPrice = priceList.find(item => item.name === cycle)

    if (selectedPrice && parseFloat(selectedPrice.price)) {
        switch (cycle) {
            case 'Quarterly':
                return parseFloat(selectedPrice.price) / 3
            case 'Semi-Annually':
                return parseFloat(selectedPrice.price) / 6
            case 'Annually':
                return parseFloat(selectedPrice.price) / 12
            case 'Biennially':
                return parseFloat(selectedPrice.price) / 24
            case 'Triennially':
                return parseFloat(selectedPrice.price) / 36
            default:
                return parseFloat(selectedPrice.price) / 12
        }
    }
    return null
}

export const getPriceByBillingCycleID = (price, billingcycleid, order_type = null) => {
    let selectedPrice = null
    if (price && price.length > 0) {
        if (price.length === 1 && price.find(item => item.name === 'One Time')) {
            selectedPrice = price.find(item => item.name === 'One Time')
        } else {
            if (order_type) {
                selectedPrice = price.find(item => item.billing_cycle_id === billingcycleid && item.type === order_type)
            } else {
                selectedPrice = price.find(item => item.billing_cycle_id === billingcycleid)
            }
        }
    }
    return selectedPrice
}

export const getPriceByBillingCycleName = (price, name) => {
    if (price && price.length > 0) {
        const selectedPrice = price.find(item => item.name === name)
        return (selectedPrice)
    }
    return (null)
}

export const getPriceListAfterDiscount = (originalPriceList,discountedPriceList) => {
    if(originalPriceList && originalPriceList.length){
        return (
            originalPriceList.map(originalPrice=>{
                const discountPrice = getPriceByBillingCycleName(discountedPriceList,originalPrice.name)
                return discountPrice? discountPrice : originalPrice
            })
        )
    }
    return  null
}

export const getBillingCycleDataFromProductConfig = (productConfig,beforePromo) => {
    //product with config options & addons
    if (productConfig && productConfig.selectedProduct && productConfig.config) {
        const { config, selectedProduct,addons } = productConfig
        if (config && config.length > 0 && selectedProduct && getAttributes(selectedProduct)) {
            const { config_options, price,discount_price } = getAttributes(selectedProduct)
            const basePriceAfterDiscount = getPriceListAfterDiscount(price,discount_price)
            const basePriceList = discount_price && !beforePromo ? basePriceAfterDiscount : price
            if (config_options && config_options.length > 0 && basePriceList && basePriceList.length > 0) {
                return basePriceList.map((baseprice) => {
                    let totalConfigPrice = parseFloat(baseprice.price) || 0
                    config.forEach((item) => {
                        const { config_id, option_id, quantity } = item
                        const selectedConfig = config_options.find(item => item.id === config_id)
                        if (selectedConfig) {
                            const { options } = selectedConfig
                            const selectedOption = options && options.length > 0 ? options.find(item => item.id === option_id) : null
                            if (selectedOption) {
                                const { price,discount_price } = selectedOption
                                const configOptionPriceAfterDiscount = getPriceListAfterDiscount(price,discount_price)
                                const priceItem = getPriceByBillingCycleID(discount_price && !beforePromo? configOptionPriceAfterDiscount:price, baseprice.billing_cycle_id)
                                if (priceItem && priceItem.price && parseFloat(priceItem.price) > 0) {
                                    if (quantity) {
                                        totalConfigPrice += quantity * parseFloat(priceItem.price)
                                    } else {
                                        totalConfigPrice += parseFloat(priceItem.price)
                                    }
                                }
                            }
                        }
                    })
                    //adding recurring addon price
                    if(addons && addons.length && Array.isArray(addons)
                        && getAttributes(productConfig.selectedProduct)
                        && getAttributes(productConfig.selectedProduct).addons
                        && getAttributes(productConfig.selectedProduct).addons.length
                    ){
                        const addonList = getAttributes(productConfig.selectedProduct).addons
                        addons.forEach(addonItem=>{
                            const selectedAddon = addonList.find(i=>i.id===addonItem.id)
                            if(selectedAddon && getAttributes(selectedAddon)){
                                const {price,discount_price} = getAttributes(selectedAddon)
                                const addonPriceAfterDiscount = getPriceListAfterDiscount(price,discount_price)
                                const priceItem = getPriceByBillingCycleID(discount_price && !beforePromo? addonPriceAfterDiscount :price, baseprice.billing_cycle_id)
                                if (priceItem && priceItem.price && parseFloat(priceItem.price) > 0) {
                                    totalConfigPrice += parseFloat(priceItem.price)
                                }
                            }
                        })
                    }
                    const newPrice = Object.assign({}, baseprice)
                    if (newPrice && newPrice.price && totalConfigPrice && totalConfigPrice.toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)) {
                        newPrice.price = totalConfigPrice.toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)
                    }
                    return newPrice
                })
            }
        }
    }
    //normal product
    if (productConfig && productConfig.selectedProduct && productConfig.selectedProduct.attributes) {
        const { price,discount_price } = productConfig.selectedProduct.attributes
        let priceList = price
        if(discount_price && discount_price.length > 0 && !beforePromo){
            priceList = getPriceListAfterDiscount(price,discount_price)
        }
        const { quantity } = productConfig
        if (quantity && priceList && priceList.length > 0) {
            const bulkprice = priceList.map(item => {
                return ({
                    ...item,
                    price: (parseFloat(item.price) * quantity).toFixed(2)
                })
            })
            return bulkprice
        }
        return priceList
    }
    return null
}

export const getYearFromPriceName = (name) => {
    //remove Year or Years
    const string = name && name.split(" ");
    return string && parseInt(string[0]);
}